import { InscriptionPartiePrenanteDto } from '@shared/src/api/inscription-partie-prenante/dto/inscription-partie-prenante.dto';
import { ParcoursPartiePrenanteDto } from '@shared/src/api/parcours-partie-prenante/dto/parcours-partie-prenante.dto';
import { useProjet } from '@shared/src/components/providers/ProjetProvider';
import { EXPERTS_GLOBAL_ID } from '@shared/src/constant/global-constants';
import { END, LAST_QUESTION, PROFILING, START, SUJET } from '@shared/src/constant/urls';
import { StatutInscription } from '@shared/src/enum/inscription-partie-prenante.enum';
import { StatutParcours } from '@shared/src/enum/parcours-partie-prenante.enum';
import { useAnsweredSujets } from '@shared/src/hooks/useAnsweredSujets';
import { useSujets } from '@shared/src/hooks/useSujets';
import { inscriptionService } from '@shared/src/services/InscriptionService';
import { Navigate, useParams } from 'react-router-dom';

export type ParcoursPageProps = {
  inscription: InscriptionPartiePrenanteDto | null;
  parcours: ParcoursPartiePrenanteDto | null;
};

// TODO : à découper en 2 !!!
/**
 * This page is used to resolve the parcours for
 * this user and redirect to the correct state of parcours
 */
export function ParcoursPage(props: ParcoursPageProps) {
  const { inscription, parcours } = props;
  const { organisationId, projetId, parcoursId } = useParams();
  const { projet } = useProjet();
  const { sujets } = useSujets(parcours?.id);
  const { answeredSujets, isAnsweredSujetsLoading } = useAnsweredSujets(props.parcours?.id);

  if (isAnsweredSujetsLoading) {
    return null;
  }

  if (inscription && inscription.statut !== StatutInscription.INSCRIT) {
    inscriptionService.update(inscription.id, { statut: StatutInscription.INSCRIT });
  }

  if (inscription && parcours && projetId && sujets) {
    switch (parcours.statut) {
      case StatutParcours.DEMARRE:
        if (!answeredSujets) {
          return (
            <Navigate to={`/${organisationId}/projets/${projetId}/stakeholders/listing/${parcoursId}${SUJET}/1`} />
          );
        } else {
          if (answeredSujets.length < sujets.length) {
            return (
              <Navigate
                to={
                  `/${organisationId}/projets/${projetId}/stakeholders/listing/${parcoursId}${SUJET}/` +
                  (answeredSujets.length + 1)
                }
              />
            );
          } else {
            if (projet?.settings?.isProfiling && !parcours?.genre) {
              return (
                <Navigate
                  to={`/${organisationId}/projets/${projetId}/stakeholders/listing/${parcoursId}${PROFILING}`}
                />
              );
            } else {
              if (EXPERTS_GLOBAL_ID.includes(parcours.__categoriePartiePrenante__.globalId ?? '')) {
                return (
                  <Navigate
                    to={`/${organisationId}/projets/${projetId}/stakeholders/listing/${parcoursId}${LAST_QUESTION}`}
                  />
                );
              } else {
                return (
                  <Navigate to={`/${organisationId}/projets/${projetId}/stakeholders/listing/${parcoursId}/${END}`} />
                );
              }
            }
          }
        }
      case StatutParcours.TERMINE:
        return <Navigate to={`/${organisationId}/projets/${projetId}/stakeholders/listing/${parcoursId}/end`} />;

      default:
        return <Navigate to={`/${organisationId}/projets/${projetId}/stakeholders/listing/${parcoursId}${START}`} />;
    }
  }
  return null;
}
